module.exports = __webpack_public_path__ + "img/icon-hlw.3534e891.png";